/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Noversions1Inputs */

const zh_publish_noversions1 = /** @type {(inputs: Publish_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无版本`)
};

const en_publish_noversions1 = /** @type {(inputs: Publish_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No versions`)
};

const es_publish_noversions1 = /** @type {(inputs: Publish_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin versiones`)
};

/**
* | output |
* | --- |
* | "No versions" |
*
* @param {Publish_Noversions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const publish_noversions1 = /** @type {((inputs?: Publish_Noversions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Noversions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_noversions1(inputs)
	if (locale === "en") return en_publish_noversions1(inputs)
	return es_publish_noversions1(inputs)
});
export { publish_noversions1 as "publish_noVersions" }